import api from '@/api/axios';

const state = {
  projectStats: [],      // 프로젝트별 크롤링 통계 (Array)
  totalStats: null,      // 전체 크롤링 통계 (Object)
  todayStats: null,      // 오늘 날짜 크롤링 통계 (Object)
  projectDailyStats: [], // 특정 프로젝트의 일별 크롤링 통계 (Array)
  isLoading: false,
  error: null,
};

const mutations = {
  SET_PROJECT_STATS(state, projectStats) {
    state.projectStats = projectStats;
  },
  SET_TOTAL_STATS(state, totalStats) {
    state.totalStats = totalStats;
  },
  SET_TODAY_STATS(state, todayStats) {
    state.todayStats = todayStats;
  },
  SET_PROJECT_DAILY_STATS(state, projectDailyStats) {
    state.projectDailyStats = projectDailyStats;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  // 프로젝트별 크롤링 통계 합계 조회
  async fetchProjectStats({ commit, rootState }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get('/api/v1/crawling_stats/project_stats');
      console.log('Project Stats response:', response.data);
      commit('SET_PROJECT_STATS', response.data);
    } catch (error) {
      console.error('Failed to fetch project stats:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch project stats');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 전체 크롤링 통계 합계 조회
  async fetchTotalStats({ commit, rootState }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get('/api/v1/crawling_stats/total_stats');
      console.log('Total Stats response:', response.data);
      commit('SET_TOTAL_STATS', response.data);
    } catch (error) {
      console.error('Failed to fetch total stats:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch total stats');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 오늘 날짜 크롤링 통계 조회
  async fetchTodayStats({ commit, rootState }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get('/api/v1/crawling_stats/today_stats');
      console.log('Today Stats response:', response.data);
      commit('SET_TODAY_STATS', response.data);
    } catch (error) {
      console.error('Failed to fetch today stats:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch today stats');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 특정 프로젝트의 일별 크롤링 통계 조회
  async fetchProjectDailyStats({ commit, rootState }, projectId) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/crawling_stats/project_daily_stats/${projectId}`);
      console.log('Project Daily Stats response:', response.data);
      commit('SET_PROJECT_DAILY_STATS', response.data);
    } catch (error) {
      console.error('Failed to fetch project daily stats:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch project daily stats');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 모든 통계를 한번에 조회
  async fetchAllStats({ dispatch }) {
    await Promise.all([
      dispatch('fetchProjectStats'),
      dispatch('fetchTotalStats'),
      dispatch('fetchTodayStats'),
    ]);
  },
};

const getters = {
  projectStats: state => state.projectStats,
  totalStats: state => state.totalStats,
  todayStats: state => state.todayStats,
  projectDailyStats: state => state.projectDailyStats,
  isLoading: state => state.isLoading,
  error: state => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
